
import { cn } from "@/lib/utils";

interface StepperDotsProps {
  currentStep: number;
  totalSteps: number;
}

export const StepperDots = ({ currentStep, totalSteps }: StepperDotsProps) => {
  return (
    <div className="flex justify-center gap-2 mt-6 mb-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "w-1.5 h-1.5 rounded-full transition-colors",
            index === currentStep - 1 
              ? "bg-black" 
              : "bg-[#E5E5E5]"
          )}
        />
      ))}
    </div>
  );
};
